<template>
  <div class="row">
    <div class="col-lg-6">
      <div
        class="modal fade"
        id="CancelServiceCenteredModal"
        tabindex="-1"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5">Cancelamento de serviço</h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              Tem certeza que deseja cancelar o serviço de armazenamento em nuvem ?
              Se você cancelar o serviço suas gravações ainda estará armazenadas por até {{ getDaysExportFiles }} dias, os arquivos serão disponibilizados via url enviada para o seu email e o serviço de upload de gravações será interrompido imediatamente
              <br>
              <div class="mt-40 mb-mb-15 mb-md-20">
                <label for="overviewPassword" class="form-label fw-medium"
                  >Digite sua senha para confirmar alteração</label
                >
                <input
                  type="password"
                  class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                  ref="passwordCancelServiceSubscription"
                  required
                />
                <div ref="errorCancelServiceSubscription" id="errorCancelServiceSubscription" class="form-text red bold" style="display: none">
                  Erro, por favor verifique a senha!.
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Fechar
              </button>
              <button ref="buttonCancelServiceSubscription" type="button" class="btn btn-danger" @click="cancelServiceSubscription">
                Cancelar serviço
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapGetters } from 'vuex';

export default {
  name: "ModalCancelService",
  computed:{
    ...mapGetters([
      "getDaysExportFiles"
    ])
  },
  methods: {
    async cancelServiceSubscription() {
      
      if(this.$refs.passwordCancelServiceSubscription.value == '' || this.$refs.passwordCancelServiceSubscription.value.length < 8 ){
        this.$refs.errorCancelServiceSubscription.style.display = "block";
        return;
      } else {
        this.$refs.errorCancelServiceSubscription.style.display = "none";
      }

      this.$refs.buttonCancelServiceSubscription.innerHTML = "Cancelando...";
      this.$refs.buttonCancelServiceSubscription.disabled = true;
      const password = this.$refs.passwordCancelServiceSubscription.value      
      const buttonCancelServiceSubscription = this.$refs.buttonCancelServiceSubscription;
      const errorCancelServiceSubscription = this.$refs.errorCancelServiceSubscription;

        await api.axios.post('/api/payment/cancel/subscription', {password}).catch(function(error){
          if(error.response.data != undefined){
            // VALIDAR ERROS
            buttonCancelServiceSubscription.disabled = false;
            buttonCancelServiceSubscription.innerHTML = "Cancelar serviço";
            errorCancelServiceSubscription.style.display = "block";
            
            console.log("error: ", error.response.data);
          }
        }).then(function(response){
          if(response != undefined && response.status == 200){
            buttonCancelServiceSubscription.innerHTML = "Serviço cancelado!"
            location.reload();
          }
        });

    }
  }
};
</script>